// extracted by mini-css-extract-plugin
export default {"wrapper":"RouteLoader_wrapper__PLfek","wrapper__inner":"RouteLoader_wrapper__inner__e945T"};